import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "renderWhenClosed", "ignorePointerEvents", "renderInPlace", "scrollContainerRef", "isOpen", "fontSize", "style", "children", "arrow", "variant", "p"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { fadeAndDropIn } from 'styles/animations';
import { visuallyHidden } from 'styles/mixins';
import Box from 'components/Box';
import Card from 'components/Card';
import Portal from 'components/Portal';
var AnimatedCard = styled(Card).withConfig({
  displayName: "PopoverCard__AnimatedCard",
  componentId: "sc-124rki1-0"
})(["z-index:", ";animation:", " 150ms ease-out;animation-fill-mode:backwards;&[data-popper-reference-hidden='true'],&[data-hidden='true']{", " visibility:hidden;pointer-events:none;animation:none;}"], function (p) {
  return p.theme.globals.z.tooltips;
}, fadeAndDropIn, visuallyHidden);
var PopoverCard = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    _ref$renderWhenClosed = _ref.renderWhenClosed,
    renderWhenClosed = _ref$renderWhenClosed === void 0 ? false : _ref$renderWhenClosed,
    _ref$ignorePointerEve = _ref.ignorePointerEvents,
    ignorePointerEvents = _ref$ignorePointerEve === void 0 ? false : _ref$ignorePointerEve,
    _ref$renderInPlace = _ref.renderInPlace,
    renderInPlace = _ref$renderInPlace === void 0 ? false : _ref$renderInPlace,
    scrollContainerRef = _ref.scrollContainerRef,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    fontSize = _ref.fontSize,
    style = _ref.style,
    children = _ref.children,
    arrow = _ref.arrow,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'raised' : _ref$variant,
    p = _ref.p,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!isOpen && !renderWhenClosed) return null;
  var Component = as || 'div';

  /*
  Warning!!! `AnimatedCard` is currently not being properly typechecked.
  Comment out `otherProps` and `forwardedAs` when making changes to check types 
  */
  return /*#__PURE__*/React.createElement(Portal, {
    targetElement: renderInPlace ? null : undefined
  }, /*#__PURE__*/React.createElement(AnimatedCard, _extends({
    ref: renderWhenClosed && !isOpen ? null : ref,
    forwardedAs: Component,
    variant: variant,
    size: "small",
    p: p,
    maxWidth: "36rem",
    width: "auto",
    "data-hidden": renderWhenClosed && !isOpen
  }, otherProps, {
    overflow: "visible",
    style: _objectSpread({
      pointerEvents: ignorePointerEvents ? 'none' : undefined
    }, style)
  }), /*#__PURE__*/React.createElement(Box, {
    ref: scrollContainerRef,
    fontSize: fontSize,
    width: "100%",
    maxHeight: "inherit"
    // Handle overflow scrolling here (instead of the parent)
    // to prevent the arrow from being cut off
    ,
    overflow: "auto"
  }, children), arrow));
});
PopoverCard.displayName = 'PopoverCard';
export default PopoverCard;